import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import loginSlice from './slices/login.js';
import userInfo from './slices/userInfo.js';
import userDetailSlice from './slices/userDetail.js';
import recordingSlice from '@/store/slices/recording.js';
import homeSlice from './slices/home.js';
import textureSlice from './slices/texture.js';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userInfo'],
};

const persistedUserInfoReducer = persistReducer(persistConfig, userInfo);

const store = configureStore({
  reducer: {
    login: loginSlice,
    userInfo: persistedUserInfoReducer,
    userDetail: userDetailSlice,
    recording: recordingSlice,
    home: homeSlice,
    texture: textureSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;
